import React from 'react';

import Layout from './src/components/structure/Layout';
import './src/assets/styles/global.css';
import './src/assets/styles/typography.css';

/**
 * https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/#wrapPageElement
 *
 * @param {ReactNode} element
 * @param {Object}    props
 *
 * @returns void
 */
export function wrapPageElement({ element, props }) {
    return (
        <Layout {...props}>{element}</Layout>
    );
}
